import { pathAndProducts } from "services/constants";
import { setCurrentLocation, setScreenAccess } from "services/Redux/userToken";
import { customGetAPIWithToken } from "./CustomAPI";
import { canUseCompanyContext, provisioningModule, provisioningRequestOrder, scopedProvisioning } from "./companyAccess";

export const resolveRouteContext = (routes, pathname) => {
  const productName = pathAndProducts.find((item) => item.pathname === pathname.split("/")[2])?.productname;
  if (!productName) return null;
  const parent = routes.find((route) => route.name === productName && (route.collapse || route.layout + route.path === pathname));
  const screen = parent?.collapse?.filter((route) => pathname === route.path || pathname.startsWith(route.path + "/"))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return { productName, screenName: screen?.name || parent?.name || productName };
};

// Resolve access for every product route, including nested pages and products
// without a sidebar collapse. Set the product before accepting its response.
export const initializeRouteAccess = async ({ routes, pathname, domain, token, companyId, userType, companies, dispatch }) => {
  const context = resolveRouteContext(routes, pathname);
  if (!context) return null;
  dispatch(setCurrentLocation(context.productName));
  if (!canUseCompanyContext(companyId, userType, companies)) return context;
  const request = provisioningRequestOrder.start();
  const response = await customGetAPIWithToken(
    `${domain}product/access/provisioning/?company_id=${encodeURIComponent(companyId)}&module=${encodeURIComponent(provisioningModule(companyId, context.productName))}`,
    token,
  );
  if (response?.ok && provisioningRequestOrder.isCurrent(request)) {
    dispatch(setScreenAccess(scopedProvisioning(response.responseDetails, companyId, context.productName)));
  }
  return context;
};
